import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

// 解决路由重复报错
const originalPath = Router.prototype.push
Router.prototype.push =  function push(location){
  return originalPath.call(this,location).catch(err=>err)
}

const routers = [
    {
      path: '/',
      name: 'index',
      component:(resolve) => require(['@/views/index'], resolve),
   },
   {
    path: '/productList',
    name: 'productList',
    component:(resolve) => require(['@/views/product/list'], resolve),
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    component:(resolve) => require(['@/views/product/detail'], resolve),
  },
  {
    path: '/marketing',
    name: 'marketing',
    component:(resolve) => require(['@/views/marketingService/index'], resolve),
  },
  {
    path: '/recruit',
    name: 'recruit',
    component:(resolve) => require(['@/views/recruitPerson/index'], resolve),
  },
  // 新闻
  {
    path: '/newsList',
    name: 'newsList',
    component:(resolve) => require(['@/views/newsAnnouncement/list'], resolve),
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component:(resolve) => require(['@/views/newsAnnouncement/detail'], resolve),
  },
  // 企业文化
  {
    path: '/culture',
    name: 'culture',
    component:(resolve) => require(['@/views/corporateCulture/index'], resolve),
  },
  // 文化建设详情
  {
    path: '/culturalConstructionDetails',
    name: 'culturalConstructionDetails',
    component:(resolve) => require(['@/views/corporateCulture/culturalConstructionDetails'], resolve),
    
  },
  // 技术支持
  {
    path: '/technology',
    name: 'technology',
    component:(resolve) => require(['@/views/technicalSupport/index'], resolve),
  },
  // 体系保障
  {
    path: '/systemGuarantee',
    name: 'systemGuarantee',
    component:(resolve) => require(['@/views/systemGuarantee/index'], resolve),
  }
]
export default new Router({
  mode:'history',
  routes:routers
})



// WEBPACK FOOTER //
// ./src/router/index.js